import { Doctor } from '@/models/domain/Doctor'
import { HealthCarrier } from '@/models/domain/HealthCarrier'
import { HealthPlan } from '@/models/domain/HealthPlan'
import { Location } from '@/models/domain/Location'
import { Patient } from '@/models/domain/Patient'
import { Product } from '@/models/domain/Product'

export const mapProduct = (product?: Product) => {
  if (!product) {
    return
  }

  return {
    id: product.idMotion,
    name: product.name
  }
}

export const mapDoctor = (doctor?: Doctor) => {
  if (!doctor) {
    return
  }

  return {
    id: doctor.idMotion,
    name: doctor.name
  }
}

export const mapLocation = (location?: Location) => {
  if (!location) {
    return
  }

  return {
    id: location.id,
    name: location.name
  }
}

export const mapPayment = (
  healthCarrier?: HealthCarrier,
  healthPlan?: HealthPlan
) => {
  if (!healthCarrier || !healthPlan) {
    return
  }

  return {
    idPlan: healthPlan.id,
    idCarrier: healthCarrier.id,
    healthCarrier: healthCarrier.name,
    healthPlan: healthPlan.name,
    isPrivate: healthPlan.isPrivate
  }
}

export const mapPatient = (patient?: Patient) => {
  if (!patient || patient.gender === null) {
    return
  }

  return {
    birthDate: patient.birthDate,
    gender: patient.gender,
    id: patient?.id
  }
}

export const getUrlParamsFromRecoveryData = (recoveryData) => {
  const hasData =
    recoveryData &&
    Object.entries(recoveryData).length > 0 &&
    Object.values(recoveryData).some(Boolean)

  if (!hasData) {
    return ''
  }

  const urlParams = new URLSearchParams()
  const searchParams = {
    especialidadem: recoveryData.product?.id,
    medicom: recoveryData.doctor?.id,
    local: recoveryData.location?.id,
    planordsl: recoveryData.payment?.idPlan,
    pacienteDataNascimento: recoveryData.patient?.birthDate,
    pacienteGenero: recoveryData.patient?.gender
  }

  for (const [key, value] of Object.entries(searchParams)) {
    if (value) {
      urlParams.set(key, value)
    }
  }

  return `?${urlParams.toString()}`
}

export const isCartRecoveryIdMismatch = ({
  recoveryUserId,
  selectedUserId
}: {
  recoveryUserId?: string
  selectedUserId?: string | null
}) => {
  return recoveryUserId !== selectedUserId
}

export const buildCartRecoveryData = ({
  doctor,
  location,
  product,
  healthCarrier,
  healthPlan,
  patient
}: {
  doctor?: Doctor
  location?: Location
  product?: Product
  healthCarrier?: HealthCarrier
  healthPlan?: HealthPlan
  patient?: Patient
}) => {
  const recoveryData = {
    doctor: mapDoctor(doctor),
    location: mapLocation(location),
    product: mapProduct(product),
    payment: mapPayment(healthCarrier, healthPlan),
    patient: mapPatient(patient)
  }

  const hasAnyData = Object.values(recoveryData).some(Boolean)

  if (!hasAnyData) {
    return null
  }

  return recoveryData
}

export const isScheduleEmpty = (schedule: {
  product?: unknown
  location?: unknown
  doctor?: unknown
  patient?: unknown
  healthCarrier?: unknown
  healthPlan?: unknown
}) => {
  return (
    !schedule.product &&
    !schedule.location &&
    !schedule.doctor &&
    !schedule.patient &&
    !schedule.healthCarrier &&
    !schedule.healthPlan
  )
}
